import * as React from "react";
import type { SVGProps } from "react";
const SvgPdfExtractionFailed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={52}
    height={71}
    fill="none"
    viewBox="0 0 52 71" {...props}
  >
    <path
      fill="#fff"
      stroke="#00217B"
      strokeWidth={0.695}
      d="m17.177 26.219-1.55 4.905L45.49 37.32l2.668-4.819zM11.24 29.836l4.13 1.29-9.466 8.004-4.733-.86zM46.352 60.642V42.828l-13.769 2.496.43 24.268z"
    />
    <path
      fill="#BED6FF"
      stroke="#00217B"
      strokeWidth={0.695}
      d="m29.93 47.045.13.027.115-.066 2.156-1.254.457 23.547a2441 2441 0 0 1-13.3-3.615 2423 2423 0 0 0-13.495-3.668V42.114z"
    />
    <path
      fill="#fff"
      stroke="#00217B"
      strokeWidth={0.695}
      d="M50.74 39.996c-1.239-1.033-4.216-2.18-5.507-2.582l-12.737 7.66 4.991 4.733z"
    />
    <path fill="#C8E0FF" d="m15.715 41.366-.258-10.241-9.38 7.917z" />
    <path
      fill="#00217B"
      d="M30.794 3.12c.027 0 .055 0 .082.014.934.193 1.965.687 3.132 1.566 2.116 1.58 2.528 5.028 1.305 8.394-.123.343-.275.687-.426 1.044-.123.26-.247.522-.384.769a14 14 0 0 1-1.14 1.744c-.261.33-.522.646-.797.935-3.2 3.448-7.432 4.41-10.262 2.665a8.2 8.2 0 0 1-1.332-1.017c-3.036-2.94-.824-6.84 2.088-10.577 2.514-3.242 4.56-6.154 7.761-5.536z"
    />
    <path
      fill="#FFDDE3"
      stroke="#00217B"
      strokeMiterlimit={10}
      strokeWidth={0.695}
      d="M32.675 4.002c-2.848-2.209-7.799-.593-11.058 3.61-3.26 4.202-3.594 9.399-.746 11.608 2.847 2.208 7.798.592 11.057-3.61s3.594-9.4.747-11.608Z"
    />
    <path
      fill="#00217B"
      d="m27.454 7.157-.163 7.137h-1.589l-.158-7.137zm-.957 10.217q-.45 0-.77-.316a1.05 1.05 0 0 1-.316-.77q0-.444.316-.76.32-.315.77-.316.44 0 .76.316.326.316.326.76 0 .302-.153.548-.149.247-.395.395-.242.143-.538.143"
    />
    <path
      fill="#fff"
      stroke="#00217B"
      strokeWidth={0.695}
      d="m30.86 49.454 1.808-5.938L5.99 37.492.74 41.967z"
    />
    <path
      stroke="#B4BCD5"
      strokeWidth={1.39}
      d="M34.648 42.487c-1.033-4.877-5.525-13.821-15.233-10.585-1.807.717-4.83 3.594 0 4.303 4.83.708 14.441-4.579 11.963-17.728"
    />
    <path
      fill="#FFCE00"
      d="M31.594 26.142a1.422 1.422 0 1 0 0-2.845 1.422 1.422 0 0 0 0 2.845"
    />
  </svg>
);
export default SvgPdfExtractionFailed;
